/* tslint:disable */
export var icon = "\n<svg width=\"31\" height=\"31\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#20455E\" fill-rule=\"evenodd\"><path d=\"M11 19h10v1H11zM11 15h8v1h-8zM11 11h6v1h-6z\"/></g></svg>\n";
//# sourceMappingURL=relevance.svg.js.map